export default __webpack_public_path__ + "static/media/Sidebar.bd18f3db.jpg";